import Card from "./Card";
function Services() {
  return (
    <div className="container services">
        <h2 className="main-title text-center">SERVICES</h2>
        <div class="parent-container">
        <div className="card-cover">
            <div className="col-md-12">
                <div className="row">
                    <div className="col-md-4 mb-2">
                        <Card title="Web Development" img="Web.jpg" text="With a focus on performance and usability, we deliver custom websites and web applications that are built to engage users and optimize business results. " />
                    </div>
                    <div className="col-md-4 mb-2">
                    <Card title="Graphic Design" img="Graphic.jpg" text="We specialize in creative and impactful graphic design that turns your ideas into powerful visuals, designed to communicate, engage, and inspire across all platforms." />
                    </div>
                    <div className="col-md-4 mb-2">
                    <Card title="Coming Soon: More Services" img="Coming Soon.jpg" text="" />
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    
  );
}
export default Services;
